<template>
  <main id="main">
    <section>
      <div class="wrapper">
        <div class="tab-btn">
          <div :class="tabValue === 1 ? 'tab tab1 active' : 'tab tab1'">
            <button type="button" @click="setCurrentTab(1)">Battery Grade</button>
          </div>
          <div :class="tabValue === 2 ? 'tab tab2 active' : 'tab tab2'">
            <button type="button" @click="setCurrentTab(2)">Battery Asset</button>
          </div>
        </div>

        <div class="select-type">
          <select class="select-style-1" @change="change_route($event)" id="route_option">
            <option value="0">All Routes</option>
            <option v-for="data in route_list" :key="data.idx" :value="data.idx">{{data.route_nm}}</option>
          </select>
        </div>
        
        <div id="tab1" :class="'tab-contents ' + (tabValue === 1 ? 'active' : '')">
          <div class="tab-contents__box tab-contents__box1">
            <h2 class="title-style-1">Grade Status</h2>
            <div class="tab-contents__box1__contents">
              <div class="container">
                <div id="anychart" ref="anychart" style="width: 100%; height: 100%;"></div>
              </div>

              <div class="chart-grade-tbl">
                <table>
                  <colgroup>
                    <col style="width: 97px" />
                    <col style="width: calc(100% - 97px)" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>Grade</th>
                      <th>Inventory</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :key=data.grade v-for="(data, i) in grade">
                      <th>
                        <span></span>
                        Grade {{ i+1 }}
                      </th>

                      <td>
                        {{ data }} vehicles
                        ({{ (100 * data / grade_total).toFixed(0) }}%)
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="tab-contents__box tab-contents__box2">
            <h2 class="title-style-1">Grade Detail</h2>
            <div class="tab-contents__box2__contents">
              <ul>
                <!-- 잔존수명 -->
                <li>
                  <p>
                    <span>Remaining Life</span>
                    <i>{{ grade_detail_grade[0] }}</i>
                  </p>
                  <table>
                    <colgroup>
                      <col style="width: calc(100% / 3)" />
                      <col style="width: calc(100% / 3)" />
                      <col style="width: calc(100% / 3)" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>Category</th>
                        <th>Score</th>
                        <th>Percentile</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Battery SOH</td>
                        <td>{{ grade_detail.bat_soh }} pts</td>
                        <td>{{ grade_detail.bat_soh }}%</td>
                      </tr>

                      <tr>
                        <td>Mileage</td>
                        <td>{{ grade_detail.car_odo_meter }} pts</td>
                        <td>{{ grade_detail.car_odo_meter }}%</td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <!--  -->

                <!-- 안전성 -->
                <li>
                  <p>
                    <span>Safety</span>
                    <i>{{ grade_detail_grade[1] }}</i>
                  </p>
                  <table>
                    <colgroup>
                      <col style="width: calc(100% / 3)" />
                      <col style="width: calc(100% / 3)" />
                      <col style="width: calc(100% / 3)" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>Category</th>
                        <th>Score</th>
                        <th>Percentile</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Cell Voltage Diff.</td>
                        <td>{{ grade_detail.cell_second_voltage }} pts</td>
                        <td>{{ grade_detail.cell_second_voltage }}%</td>
                      </tr>

                      <tr>
                        <td>Module Temp. Diff.</td>
                        <td>{{ grade_detail.cell_sub_temperature }} pts</td>
                        <td>{{ grade_detail.cell_sub_temperature }}%</td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <!--  -->

                <!-- 사용성 -->
                <li>
                  <p>
                    <span>Usability</span>
                    <i>{{ grade_detail_grade[2] }}</i>
                  </p>
                  <table>
                    <colgroup>
                      <col style="width: calc(100% / 3)" />
                      <col style="width: calc(100% / 3)" />
                      <col style="width: calc(100% / 3)" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>Category</th>
                        <th>Score</th>
                        <th>Percentile</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Rapid Accel/Decel</td>
                        <td>{{ grade_detail.car_rapid }} pts</td>
                        <td>{{ grade_detail.car_rapid }}%</td>
                      </tr>

                      <tr>
                        <td>Cabin Temp.</td>
                        <td>{{ grade_detail.car_inside_temperature }} pts</td>
                        <td>{{ grade_detail.car_inside_temperature }}%</td>
                      </tr>

                      <tr>
                        <td>Charge/Discharge</td>
                        <td>{{ 0 }} pts</td>
                        <td>{{ 0 }}%</td>
                      </tr>
                    </tbody>
                  </table>
                </li>
              </ul>
            </div>
          </div>

          <div class="tab-contents__box tab-contents__box3">
            <h2 class="title-style-1">MoM Route Performance</h2>
            <div class="tab-contents__box3__select">
              <select class="select-style-1" v-model="orderby_option" name="" id="">
                <option value="0" v-if="route_option == 0">Sort by Grade</option>
                <option value="1">Sort by Route</option>
              </select>
            </div>
            <div class="tab-contents__box3__contents">
              <Table1
                :route_option="route_option"
                :table_column="table_column"
                :orderby_option="orderby_option"
                @setPopupFlag="setPopupFlag"
                @setPopupCarNumber="setPopupCarNumber"
                @setPopupbatGrade="setPopupbatGrade"
              />
            </div>
          </div>
        </div>

        <div id="tab2" :class="'tab-contents ' + (tabValue === 2 ? 'active' : '')">
          <div class="tab-contents__box tab-contents__box1">
            <div class="current">
              <div class="title">
                <h3>This Month</h3>
              </div>
              <ul>
                <li> 
                  <div class="icon"></div>
                  <div class="desc">
                    <p>Electric Buses</p>
                    <span>{{ asset[0]['cnt']}} vehicles</span>
                  </div>
                </li>
                <li>
                  <div class="icon"></div>
                  <div class="desc">
                    <p>Avg. Expected Life (SOH)</p>
                    <span>{{asset[0]['bat_soh']}}%</span>
                  </div>
                </li>
                <li>
                  <div class="icon"></div>
                  <div class="desc">
                    <p>Avg. Grade</p>
                    <span>Grade {{asset[0]['bat_grade']}}</span>
                  </div>
                </li>
               <li>
                  <div class="icon"></div>
                  <div class="desc">
                    <p>Original Value</p>
                    <span>{{asset[0]['val']}} KRW</span>
                  </div>
                </li>
                <li>
                  <div class="icon"></div>
                  <div class="desc">
                    <p>Cumulative Improvement</p>
                    <span v-html="asset[0]['val_prov']"></span>
                  </div>
                </li>
                <li>
                  <div class="icon"></div>
                  <div class="desc">
                    <p>Current Asset Value</p>
                    <span>{{asset[0]['val_now']}} KRW</span>
                  </div>
                </li>
              </ul>
            </div>

            <div class="before">
              <div class="title">
                <h3>Last Month</h3>
              </div>
              <ul>
                <li>
                  <div class="icon"></div>
                  <div class="desc">
                    <p>Electric Buses</p>
                    <span>{{ asset[1]['cnt']}} vehicles</span>
                  </div>
                </li>
                <li>
                  <div class="icon"></div>
                  <div class="desc">
                    <p>Avg. Expected Life (SOH)</p>
                    <span>{{asset[1]['bat_soh']}}%</span>
                  </div>
                </li>
                <li>
                  <div class="icon"></div>
                  <div class="desc">
                    <p>Avg. Grade</p>
                    <span>Grade {{asset[1]['bat_grade']}}</span>
                  </div>
                </li>
                <li>
                  <div class="icon"></div>
                  <div class="desc">
                    <p>Original Value</p>
                    <span>{{asset[1]['val']}} KRW</span>
                  </div>
                </li>
                <li>
                  <div class="icon"></div>
                  <div class="desc">
                    <p>Cumulative Improvement</p>
                    <span v-html="asset[1]['val_prov']"></span>
                  </div>
                </li>
                <li>
                  <div class="icon"></div>
                  <div class="desc">
                    <p>Current Asset Value</p>
                    <span>{{asset[1]['val_now']}} KRW</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
         <div class="tab-contents__box tab-contents__box2">
            <h2 class="title-style-1">Asset Value Trend</h2>
            <div class="container">
              <div id="anychart3" ref="anychart3" style="width: 100%; height: 100%;"></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Popup1
      :popupFlag="popupFlag"
      :popupCarNumber="popupCarNumber"
      :grade="popupbatGrade"
      @setPopupCloseFlag="setPopupCloseFlag"
    />
  </main>  
</template>

<script>
import anychart from 'anychart'
import GradeStatusTable1 from '@/components/page/GradeStatusTable1';
import GradeStatusPopup1 from '@/components/page/GradeStatusPopup1';

export default {
  name: 'GradeStatus',

  components: {
    'Table1': GradeStatusTable1,
    'Popup1': GradeStatusPopup1
  },

  data () {
    return {
      tabValue: 1,
      route_option: 0,
      route_list: '',
      grade: [0,0,0,0,0],
      grade_total: 0,
      grade_detail:{
          bat_soh: 0,
          car_odo_meter: 0,
          cell_second_voltage: 0,
          cell_sub_temperature: 0,
          car_rapid: 0,
          car_inside_temperature: 0
      },
      grade_detail_grade:['A','A','A'],
      table_column: 'Route No.',
      popupFlag: false,
      popupCarNumber: 0,
      popupbatGrade: 0,
      asset: [
        {
          cnt: '',
          bat_soh: '',
          bat_grade: '',
          val: '',
          val_prov: '',
          val_now: '',
        },
        {
      cnt: '',
      bat_soh: '',
      bat_grade: '',
      val: '',
      val_prov: '',
      val_now: '',
    },
      ],
    chart3_data: '',
    orderby_option: '0',
    }
    
  },

  mounted () {
    // kps
    this.get_route_list();
    this.gradestatus_get_grade();
    this.gradestatus_get_grade_detail();
  },
  
  methods: {
    // 옵션 선택시 데이터 새로 설정
    change_route (event){
      this.route_option = event.target.value; // 라우터 옵션 값 변경
      this.orderby_option = '1';
      
      this.gradestatus_get_grade(); // 등급 현황 변경
      this.gradestatus_get_grade_detail(); // 등급 현황 상세 내용 변경
      this.table_column = (this.route_option == 0) ? "Route No." : "Vehicle No."; // 테이블 데이터 변경
  },

    get_route_list () {
      var post_data = {group_id: this.$store.getters.getGroupId};
      this.$axios.post('/api/get_route_list', post_data).then(res => {
        this.route_list = res.data.rows;
      });
    },

    // 등급 상세데이터 가져오기
    gradestatus_get_grade_detail: function(){
      var post_data = {route_option: this.route_option, group_id: this.$store.getters.getGroupId}
        this.$axios.post('/api/gradestatus_get_grade_detail', post_data).then(res => {
          this.grade_detail = res.data.result[0];
          this.grade_detail_grade = res.data.result[1];
        });
    },
    
    // 등급(대수) 가져오기
    gradestatus_get_grade: function(){
      var post_data = {route_option: this.route_option, group_id: this.$store.getters.getGroupId}
      this.$axios.post('/api/gradestatus_get_grade', post_data).then(res => {
        this.grade = res.data.result[0];
        this.grade_total = res.data.result[1];
        
        // 0으로 나누는거 방지
        if(this.grade_total == 0) {this.grade_total = 1;}
        
        this.anychart1();
      });
    },
    
    get_asset: function(){
      var post_data = {route_option: this.route_option, group_id: this.$store.getters.getGroupId}
      this.$axios.post('/api/gradestatus_get_asset', post_data).then(res => {
        var arr = [];
        arr[0] = res.data.result[0];
        arr[1] = res.data.result[1];
        this.asset = arr;

        this.chart3_data = res.data.result[2];
        this.anychart3();
      });
    },

    anychart1: function () {
      this.$refs.anychart.innerHTML = "";
      anychart.onDocumentReady(() => {
        // 모든 데이터가 0인지 확인
        var exists = 0;
        for(var i=0; i<(this.grade).length;i++) {
          if(this.grade[i] != 0) {
            exists = 1; 
            break;
          }
        }
        // 
        
        // 모든데이터가 0이면 빈차트 출력
        var chart = "";
        if(exists == 0) {
          chart = anychart.pie();
          chart.noData().label().enabled(true);
          chart.noData().label().text("No Data");
        }else {
          chart = anychart.pie([
                ['Grade 1', this.grade[0]],
                ['Grade 2', this.grade[1]],
                ['Grade 3', this.grade[2]],
                ['Grade 4', this.grade[3]],
                ['Grade 5', this.grade[4]]
              ]);
        }

        var palette = anychart.palettes.rangeColors();
        palette.items([{ color: '#7dc8bc' }, { color: '#69c4c5' }, {color: '#37b8af'}, {color: '#28ac8b'}, {color: '#15897a'}]);

        // set chart title text settings
        chart
        //.title('등급현황')
        .legend(false)
        .palette(palette)
        .tooltip()
        .format('{%Value}{groupsSeparator: } vehicles');
        // set points grouping settings

        //chart.legend().position('right').itemsLayout('vertical');

        //워터마커 제거
        anychart.licenseKey("4dream-8254134a-23a23715");
        var credits = chart.credits();
        credits.enabled(false);
        
        // turn on chart animation
        chart.animation(true);

        // set container id for the chart
        chart.container('anychart');
        // initiate chart drawing
        chart.draw();
      });
    },

    // 자산현황 차트
    anychart3: function () {
      this.$refs.anychart3.innerHTML = "";
      anychart.onDocumentReady(() => {
        // create line chart
        var chart = anychart.line();

        // set chart padding
        chart.padding([10, 20, 5, 20]);

        // turn on chart animation
        chart.animation(true);

        // turn on the crosshair
        //chart.crosshair(true);

        // set chart title text settings
        chart.title('Asset Value Trend');

        // set y axis title
        chart.yAxis().title('Value (100M KRW)');

        // create logarithmic scale
        //var logScale = anychart.scales.log();
        //logScale.minimum(1).maximum(45000);

        // set scale for the chart, this scale will be used in all scale dependent entries such axes, grids, etc
        //chart.yScale(logScale);

        var dataSet = anychart.data.set(this.chart3_data);

        // map data for the first series,take value from first column of data set
        var firstSeriesData = dataSet.mapAs({ x: 0, value: 1 });

        // map data for the second series,take value from second column of data set
        var secondSeriesData = dataSet.mapAs({ x: 0, value: 2 });

        // temp variable to store series instance
        var series;

        // setup second series
        series = chart.line(firstSeriesData);
        series.name('Current Asset Value');
        // enable series data labels
        series.labels().enabled(true).anchor('left-bottom').padding(5);
        // enable series markers
        series.markers(true);

        // setup third series
        series = chart.line(secondSeriesData);
        series.name('Original Value');
        // enable series data labels
        series.labels().enabled(true).anchor('left-bottom').padding(5);
        // enable series markers
        series.markers(true);

        // turn the legend on
        chart.legend().enabled(true).fontSize(13).padding([0, 0, 20, 0]);
        
        //워터마커 제거
        anychart.licenseKey("4dream-8254134a-23a23715");
        var credits = chart.credits();
        credits.enabled(false);

        // grid set
        chart.yGrid(true);
        
        chart
        .tooltip()
        .displayMode('separated')
        .positionMode('point')
        .separator(false)
        .position('right')
        .anchor('left-bottom')
        .offsetX(2)
        .offsetY(5)
        .title(false)
        .format('{%Value} 100M KRW');
        
        // set container for the chart and define padding
        chart.container('anychart3');
        // initiate chart drawing
        chart.draw();
      });
    },

    // tab click event
    setCurrentTab (num) {
      if (typeof num !== 'number' || (num !== 1 && num !== 2)) this.tabValue = 1;
      else this.tabValue = num;
      
      if(num == 2) {
        this.get_asset(); // 배터리 자산현황 데이터 변경
      }
    },
    setPopupFlag (flag) {
      this.popupFlag = flag
    },
    setPopupCloseFlag (flag) {
      this.popupFlag = flag
    },
    setPopupCarNumber (car_number) {
      this.popupCarNumber = car_number
    },
    setPopupbatGrade (bat_grade) {
      this.popupbatGrade = bat_grade
    }
    
  },
}
</script>

<style lang="scss" scoped>
$defaultMargin: 25px;

#main {
  overflow: hidden;

  section {
    width: 100%;
    height: 100%;
    padding: $defaultMargin;
    overflow: auto;
    @include mobile {
      padding: 10px;
    }
  }

  .wrapper {
    width: 100%;
    min-width: 1400px;
    min-height: 100%;
    position: relative;
    @include mobile {
      min-width: 100%;
    }
  }

  .tab-btn {
    width: 100%;
    height: 40px;
    margin-bottom: $defaultMargin;
    display: flex;
    @include mobile {
      margin-bottom: 50px;
      height: 50px;
    }

    .tab {
      width: 172px;
      height: 100%;
      margin-right: 25px;
      box-shadow: none;
      &:last-child {
        margin-right: 0;
      }
      @include mobile {
        width: calc((100% - 10px) / 2);
        margin-right: 10px;
      }

      button {
        width: 100%;
        height: 100%;
        border: 1px solid #d2e7e0;
        color: #9dd0d1;
        border-radius: 6px;
        background: #fff;
        font-size: 18px;
        font-weight: 600;
        @include mobile {
          border-radius: 4px;
        }
      }

      &.active {
        button {
          color: #292929;
          border: 1px solid #21938c;
          box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.2);
        }
      }
    }
  }

  .select-type {
    position: absolute;
    top: 17px;
    right: 0;
    @include mobile {
      top: 60px;
      width: 120px;
      select {
        width: 100%;
      }
    }
  }

  .tab-contents {
    display: none;
    &.active {
      display: grid;
      @include mobile {
        display: flex;
        flex-direction: column;
      }
    }
    &__box {
      border: 1px solid #979797;
      border-radius: 5px;
      padding: 25px;
      background: #fff;
      @include mobile {
        padding: 10px;
      }
    }
  }

  #tab1 {
    grid-template-columns: 3.75fr 6.25fr;
    grid-template-rows: 4.74fr 5.26fr;
    gap: $defaultMargin;
    @include mobile {
      gap: 10px;
    }

    .tab-contents {
      &__box1 {
        &__contents {
          height: 246px;
          display: flex;
          justify-content: space-between;

          #chart-grade {
            width: calc(43.7% - 33px);
            height: 100%;
          }

          .container {
            width: 43.7%;
            height: 100%;
          }

          .chart-grade-tbl {
            width: 56.3%;
            height: 100%;
            border: 1px solid #5c5c5c;
            border-radius: 6px;

            table {
              width: 100%;
              height: 100%;
              text-align: center;

              thead {
                border-bottom: 1px solid #5c5c5c;

                th {
                  background: #077f80;
                  color: #fff;
                  height: 37px;

                  &:first-child {
                    border-right: 1px solid #fff;
                  }
                }
              }

              tbody {
                font-size: 15px;

                tr {
                  min-height: 25px;
                  th {
                    font-weight: 500;
                    border-right: 1px solid #5c5c5c;

                    span {
                      display: inline-block;
                      width: 20px;
                      height: 20px;
                      border-radius: 2px;
                      background: #000;
                      vertical-align: -5px;
                      margin-right: 4px;
                    }
                  }

                  &:nth-child(1) th span {
                    background: #7dc8bc;
                  }

                  &:nth-child(2) th span {
                    background: #69c4c5;
                  }

                  &:nth-child(3) th span {
                    background: #37b8af;
                  }

                  &:nth-child(4) th span {
                    background: #28ac8b;
                  }

                  &:nth-child(5) th span {
                    background: #15897a;
                  }
                }
              }
            }
          }
        }
      }

      &__box2 {
        &__contents {
          height: calc(100% - 54px);
          ul {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            height: 100%;
            gap: 24px;
            @include mobile {
              display: flex;
              flex-direction: column;
              gap: 10px;
            }

            li {
              border: 1px solid #5c5c5c;
              border-radius: 6px;
              height: 100%;
              padding: 25px 0;
              display: flex;
              flex-direction: column;
              align-items: center;
              @include mobile {
                padding: 10px;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
              }

              p {
                width: 87px;
                height: 87px;
                border-radius: 50%;
                background: #7dc8bc;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin-bottom: 3px;
                @include mobile {
                  margin-bottom: 0;
                }

                span {
                  color: #022121;
                  font-size: 15px;
                  font-weight: 600;
                }

                i {
                  color: #fff;
                  font-weight: 700;
                  font-size: 35px;
                }
              }

              table {
                width: calc(100% - 34px);
                text-align: center;
                @include mobile {
                  width: calc(100% - 100px);
                }

                thead {
                  border-bottom: 1px solid #5c5c5c;

                  th {
                    height: 41px;
                    font-size: 15px;
                  }
                }

                tbody {
                  tr {
                    &:first-child {
                      td {
                        padding-top: 5px;
                        height: 30px;
                        @include mobile {
                          height: 25px;
                        }
                      }
                    }
                    td {
                      height: 25px;
                      white-space: nowrap;
                      font-size: 13px;
                      @include mobile {
                        height: 20px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      &__box3 {
        grid-column: 1/3;
        grid-row: 2/3;
        position: relative;

        &__select {
          position: absolute;
          top: 20px;
          right: 15px;
          @include mobile {
            top: 10px;
            right: 10px;
          }
        }

        &__contents {
          height: 303px;
        }
      }
    }
  }

  #tab2 {
    .tab-contents {
      &__box1 {
        width: 100%;
        overflow-x: auto;
        padding-top: 14px;
        padding-bottom: 14px;
        margin-bottom: $defaultMargin;
        @include mobile {
          margin-bottom: 10px;
        }

        >div {
          display: flex;
          min-height: 133px;
          @include mobile {
            flex-direction: column;
          }
        }

        .title {
          display: flex;
          align-items: center;
          h3 {
            padding: 36px 24px;
            border-radius: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            background: #000;
            font-size: 30px;
            font-weight: 700;
            white-space: nowrap;
            @include mobile {
              width: 100%;
              padding: 8px 0;
              border-radius: 0;
              font-size: 20px;
            }
          }
        }

        ul {
          display: flex;
          align-items: center;
          @include mobile {
            flex-wrap: wrap;
            margin-top: 15px;
          }

          li {
            margin: 0 25px;
            display: flex;
            height: 100%;
            @include mobile {
              width: calc((100% - 10px) / 3);
              margin: 0;
              flex-direction: column;
              justify-content: flex-start;
              align-items: center;
              height: 140px;
            }

            .icon {
              width: 70px;
              height: 100%;
              background-repeat: no-repeat;
              background-position: center;
              background-size: 100%;
              @include mobile {
                height: 73px;
              }
            }
            &:nth-child(1) .icon {
              background-image: url('~@/assets/images/batt-assets-images-1.svg');
            }
            &:nth-child(2) .icon {
              background-image: url('~@/assets/images/batt-assets-images-2.svg');
            }
            &:nth-child(3) .icon {
              background-image: url('~@/assets/images/batt-assets-images-3.svg');
            }
            &:nth-child(4) .icon {
              background-image: url('~@/assets/images/batt-assets-images-4.svg');
            }
            &:nth-child(5) {
              .icon {
                background-image: url('~@/assets/images/batt-assets-images-5.svg');
              }
              .desc {
                margin-top: 28px;
                @include mobile {
                  margin-top: 0;
                }
                span {
                  color: #36bb8e;
                }
              }
            }
            &:nth-child(6) .icon {
              background-image: url('~@/assets/images/batt-assets-images-6.svg');
            }

            .desc {
              width: 129px;
              margin: 0 0 0 10px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              @include mobile {
                width: calc(100% - 20px);
              }
              p {
                width: 100%;
                font-size: 14px;
                font-weight: 600;
                color: #101010;
                border-bottom: 1px solid #5c5c5c;
                padding: 8px 0;
                text-align: center;
                white-space: nowrap;
                @include mobile {
                  padding: 3px 0;
                  font-size: 12px;
                }
              }
              span {
                font-size: 20px;
                color: #e98900;
                font-weight: 600;
                display: block;
                padding: 9px 0;
                white-space: nowrap;
                text-align: center;
                @include mobile {
                  padding: 3px 0;
                  font-size: 14px;
                }
              }
            }
          }
        }

        .current {
          h3 {
            background: #7dc8bc;
          }
          @include mobile {
            ul {
              margin-bottom: 15px;
            }
          }
        }
        .before {
          h3 {
            background: #21938c;
          }
        }
      }

      &__box2 {
        width: 100%;
        height: 400px;
        position: relative;
        @include mobile {
          height: 350px;
        }
        .title-style-1 {
          position: relative;
          z-index: 1;
          margin-bottom: 0;
        }
        .container {
          position: absolute;
          top: 25px;
          left: 25px;
          width: calc(100% - 50px);
          height: calc(100% - 50px);
          @include mobile {
            top: 10px;
            left: 10px;
            width: calc(100% - 20px);
            height: calc(100% - 20px);
          }
        }
      }
    }
  }
}
</style>